import { render } from "./ShareTemplateModal.vue?vue&type=template&id=6e136384&scoped=true"
import script from "./ShareTemplateModal.vue?vue&type=script&lang=js"
export * from "./ShareTemplateModal.vue?vue&type=script&lang=js"

import "./ShareTemplateModal.vue?vue&type=style&index=0&id=6e136384&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e136384"]])

export default __exports__